import { render, staticRenderFns } from "./JoiningApplicationEducationalAddToGroup.vue?vue&type=template&id=1ecc86a1&"
import script from "./JoiningApplicationEducationalAddToGroup.vue?vue&type=script&lang=js&"
export * from "./JoiningApplicationEducationalAddToGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports